import { TUserContactInfo } from './apiServices'

export interface IJobAlertData {
    industry: []
    level: number
    location: string
    salary: string
    title: string
    ['year_of_exp']: number
    locationId: number
    summary: string
}

export type TContactInfoRef = {
    onSubmit: () => void
}

export type TWorkingReferenceRef = {
    onSubmit: () => void
}

export type TRecommendItem = {
    id: number
    name: string
}
export type TOption = {
    id: number
    name: string
    nameEn: string
}
export type TUserContactInfoData = TUserContactInfo & { birthday: Date | null }

export enum EMaritalStatus {
    'NEW' = 0,
    'SINGLE' = 1,
    'MARRIED' = 2
}

export enum EGender {
    'MALE' = 1,
    'FEMALE' = 2
}

export enum ETab {
    'UPLOAD_CV' = 1,
    'CONTACT_INFORMATION' = 2,
    'WORKING_PREFERENCE' = 3
}

export type TRegisterFormData = {
    fullName: string
    email: string
    phone: string
    jobLevelId: number
    highestdegreeId: number
    cityId: number
    industryId: number
    eventId: number
}

export type TJobFunction = {
    parentId: number
    childrenIds: number[]
}

export type TWorkingPreferencesData = {
    jobTitle: string
    jobLevelId: number
    locations: number[]
    industries: number[]
    companyIndustries: number[]
    salary: number
    isSearchable: number
    yearsExperience: number
    highestDegreeId: number
    resumeId: number
    jobFunction: TJobFunction[]
}
export type TContactProps = {
    initialData?: TUserContactInfoData
    onCancel: () => void
    onSave: (data: TUserContactInfoData) => void
}
